<template>
  <div>
    <div class="pb-5" data-wizard-type="step-content">
      <div class="row">
        <div class="col-xl-12">
          <h4 v-if="course.id">Saisissez les informations à modifier</h4>

          <h4 v-else class="mb-10 font-weight-bold text-dark text-center">
            Vous pouvez revenir sur les étapes prédédentes pour modifier les champs.<br/><br/>
			Pour enregistrer votre formulaire, veuillez appuyer sur "VALIDER".
          </h4>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "formCourseStep3",

  model: {
    prop: "course",
    event: "input",
  },
  props: {
    course: Object,
  },
};
</script>
